module.exports = __webpack_public_path__ + "img/notetabletsmart.a86412b9.svg";